"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.siloPosReducer = exports.siloPosAction = exports.siloPosTypes = void 0;
const silo_pos_action_1 = __importDefault(require("./silo-pos.action"));
exports.siloPosAction = silo_pos_action_1.default;
const silo_pos_reducer_1 = __importDefault(require("./silo-pos.reducer"));
exports.siloPosReducer = silo_pos_reducer_1.default;
const silo_pos_sub_component_1 = __importDefault(require("./sub-components/silo-pos.sub-component"));
const silo_pos_types_1 = require("./silo-pos.types");
Object.defineProperty(exports, "siloPosTypes", { enumerable: true, get: function () { return silo_pos_types_1.siloPosTypes; } });
exports.default = silo_pos_sub_component_1.default;
